<template>
  <v-card id="user-settings-card">
    <!-- tabs -->
    <v-tabs
      v-model="tab"
      show-arrows
      grow
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.icon"
        @click="getUser"
      >
        <v-icon
          size="20"
          class="me-3"
        >
          {{ tab.icon }}
        </v-icon>
        <span>{{ tab.title }}</span>
      </v-tab>
    </v-tabs>

    <!-- tabs item -->
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <conta-settings
          :key="usuario.id"
          :account-data="usuario"
          :acesso-put="acessoPut"
        >
        </conta-settings>
      </v-tab-item>

      <v-tab-item>
        <conta-settings-security
          :key="usuario.id"
          :security-data="usuario"
          :acesso-put="acessoPut"
        >
        </conta-settings-security>
      </v-tab-item>

      <v-tab-item>
        <conta-settings-info
          :key="usuario.id"
          :info-data="usuario"
          :acesso-put="acessoPut"
        >
        </conta-settings-info>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import {
  mdiAccountOutline,
  mdiBellOutline,
  mdiBookmarkOutline,
  mdiInformationOutline,
  mdiLockOpenOutline,
  mdiCloseCircleOutline,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import { mapState } from 'pinia'

// demos
import ContaSettings from '@/views/conta/ContaSettings.vue'
import ContaSettingsSecurity from '@/views/conta/ContaSettingsSecurity.vue'
import ContaSettingsInfo from '@/views/conta/ContaSettingsInfo.vue'
import useAuthStore from '@/store/auth'
import useUserStore from '@/store/user'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  components: {
    ContaSettings,
    ContaSettingsSecurity,
    ContaSettingsInfo,
  },

  data() {
    return {
      usuario: {},
      idPut: 2030,
      acessoPut: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
    ...mapState(useUserStore, ['id']),
  },

  mounted() {
    this.getUser()
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPut)) {
        this.acessoPut = false
      }
    },

    async getUser() {
      this.usuario = await ColaboradorService.getById(this.id)
    },
  },

  setup() {
    const tab = ref('')

    // tabs
    const tabs = [
      { title: 'Conta', icon: mdiAccountOutline },
      { title: 'Segurança', icon: mdiLockOpenOutline },
      { title: 'Informações', icon: mdiInformationOutline },
    ]

    // account settings data
    const accountSettingData = {}

    return {
      tab,
      tabs,
      accountSettingData,
      icons: {
        mdiAccountOutline,
        mdiLockOpenOutline,
        mdiInformationOutline,
        mdiBookmarkOutline,
        mdiBellOutline,
        mdiCloseCircleOutline,
      },
    }
  },
}
</script>
